<template>
  <div class="pa-5 pt-2 mt-3">
    <master-lists-data-table :refresh="isRefresh" />
  </div>
</template>
<script>
import MasterListsDataTable from './DataTable'
export default {
  name: 'campaign-master-lists',
  components: {
    MasterListsDataTable
  },
  props: [
    'refresh'
  ],
  data() {
    return {
      isRefresh: 1
    }
  },
  methods: {
    reload() {
      this.isRefresh += 1
    }
  }
}
</script>



// WEBPACK FOOTER //
// index.vue?72e4d168